import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getInitialSessionBudget } from '../SalesAttribution/SalesAttributionView/Summary/saveLoadAdSpend';
import { CampaignSchema } from './schemas/campaign';

type DashboardState = {
  ui: {
    selectedChannel: string | null;
    selectedReportDate: string | null;
    sessionBudget: Record<CampaignSchema['id'], number | null>;
  };
};

const initialState: DashboardState = {
  ui: {
    selectedChannel: null,
    selectedReportDate: null, // TODO: Move away from using date if possible
    sessionBudget: getInitialSessionBudget() ?? {},
  },
};

export const dashboardSlice = createSlice({
  name: 'dashboardSlice',
  initialState,
  reducers: {
    reportSelected(state, { payload }: PayloadAction<string | null>) {
      state.ui.selectedReportDate = payload;
    },

    sessionBudgetUpdated(
      state,
      {
        payload,
      }: PayloadAction<{
        campaignId: CampaignSchema['id'];
        sessionBudget: number | null;
      }>
    ) {
      state.ui.sessionBudget = {
        ...state.ui.sessionBudget,
        [payload.campaignId]: payload.sessionBudget,
      };
    },
  },
});

export const { reportSelected } = dashboardSlice.actions;
